import { render, staticRenderFns } from "./MyTicketsPage.vue?vue&type=template&id=94dee18e&scoped=true"
import script from "./MyTicketsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyTicketsPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MyTicketsPage.vue?vue&type=style&index=0&id=94dee18e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94dee18e",
  null
  
)

export default component.exports